import withLabelAndError from './withLabelAndError';

import TextInput from './TextInput';

const TextInputWithLabelAndError = withLabelAndError(TextInput);

export { TextInput, TextInputWithLabelAndError };
